import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=543af8fc&scoped=true&lang=css"

import exportComponent from "E:\\WorkProject\\xiaodangjia\\investor_Vant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543af8fc"]])

export default __exports__